import React, { Component } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";

type Step = "LOGIN" | "OTP";

interface State {
  step: Step;
  email: string;
  otp: string;
  loading: boolean;
}

class OTPLoginMain extends Component<any, State> {
  state: State = {
    step: "LOGIN",
    email: "",
    otp: "",
    loading: false,
  };

  handleSendOtp = () => {
    this.setState({ loading: true });

    // TODO: call backend API to send OTP
    setTimeout(() => {
      this.setState({
        loading: false,
        step: "OTP",
      });
    }, 1200);
  };

  handleVerifyOtp = () => {
    this.setState({ loading: true });

    // TODO: call backend API to verify OTP
    setTimeout(() => {
      this.setState({ loading: false });
      alert("Login successful");
    }, 1200);
  };

  renderLogin() {
    const { email, loading } = this.state;

    return (
      <>
        <TextField
          fullWidth
          label="Email Address"
          type="email"
          margin="normal"
          value={email}
          onChange={(e) => this.setState({ email: e.target.value })}
        />

        <Button
          fullWidth
          variant="contained"
          size="large"
          sx={{ mt: 2 }}
          disabled={!email || loading}
          onClick={this.handleSendOtp}
        >
          {loading ? <CircularProgress size={24} /> : "Send OTP"}
        </Button>
      </>
    );
  }

  renderOtp() {
    const { otp, loading } = this.state;

    return (
      <>
        <TextField
          fullWidth
          label="One-Time Password"
          margin="normal"
          value={otp}
          onChange={(e) => this.setState({ otp: e.target.value })}
          inputProps={{
            maxLength: 6,
            style: {
              textAlign: "center",
              letterSpacing: "0.3em",
            },
          }}
        />

        <Button
          fullWidth
          variant="contained"
          size="large"
          sx={{ mt: 2 }}
          disabled={otp.length !== 6 || loading}
          onClick={this.handleVerifyOtp}
        >
          {loading ? <CircularProgress size={24} /> : "Verify OTP"}
        </Button>

        <Button
          fullWidth
          variant="text"
          sx={{ mt: 1 }}
          onClick={() => this.setState({ step: "LOGIN", otp: "" })}
        >
          Change Email
        </Button>
      </>
    );
  }

  render() {
    const { step } = this.state;

    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.default",
        }}
      >
        <Card sx={{ width: 380, boxShadow: 6 }}>
          <CardContent sx={{ p: 4 }}>
            <Typography
              variant="h5"
              textAlign="center"
              fontWeight={600}
              mb={1}
            >
              Secure Login
            </Typography>

            <Typography
              variant="body2"
              textAlign="center"
              color="text.secondary"
              mb={3}
            >
              {step === "LOGIN"
                ? "Enter your email to receive a one-time password"
                : "Enter the 6-digit OTP sent to your email"}
            </Typography>

            {step === "LOGIN" ? this.renderLogin() : this.renderOtp()}
          </CardContent>
        </Card>
      </Box>
    );
  }
}

export default OTPLoginMain;